import AreaPage from "@/components/AreaPage";

const area = {
  name: "Golf Course Road",
  slug: "water-tank-cleaning-golf-course-road-gurugram",
  h1: "Water Tank Cleaning in Golf Course Road, Gurugram",
  description: "Professional water tank cleaning on Golf Course Road, Gurugram. Premium apartments and commercial buildings served.",
  content1: "Golf Course Road is one of Gurugram's most premium residential corridors, home to high-rise luxury apartments like DLF The Crest, Ireo Grand Arch, Central Park Resorts, and M3M Golf Estate. TankBuddy provides specialized water tank cleaning services for these large residential complexes, handling tanks from 5,000 to 50,000+ litres with industrial-grade equipment and certified technicians.",
  content2: "With several commercial towers and hospitality establishments along Golf Course Road, TankBuddy also serves hotels, co-working spaces, and corporate offices requiring compliance-grade tank cleaning with proper documentation. Our team understands the scheduling constraints of luxury communities and works around your convenience — early mornings, weekends, or holidays. Same-day service available for urgent requirements.",
  nearby: [
    { href: "/water-tank-cleaning-dlf-phase-gurugram", label: "DLF Phase 1-5" },
    { href: "/water-tank-cleaning-sohna-road-gurugram", label: "Sohna Road" },
    { href: "/water-tank-cleaning-sector-56-57-gurugram", label: "Sector 56-57" },
    { href: "/water-tank-cleaning-nirvana-country-gurugram", label: "Nirvana Country" },
  ],
};

export default function GolfCourseRoadPage() {
  return <AreaPage area={area} />;
}
